import "./radio-button.scss";

export interface IRadioButtonProps {
    name: string;
    checked?: boolean;
    value?: number | string;
    disabled?: boolean;
    onChange?(checked: boolean): void;
}

export const RadioButton: React.FC<IRadioButtonProps> = ({ name, checked, disabled = false, onChange = () => { } }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e.target.checked);
        }
    }

    return (
        <div className={`radio-button-block${disabled ? ' disabled' : ''}`}>
            <input
                type="radio"
                disabled={disabled}
                checked={checked ?? false}
                name={name}
                onChange={handleChange}
            />
            <span className="radio"></span>
        </div>
    );
}